import { render, staticRenderFns } from "./ScansPage.vue?vue&type=template&id=6ed794d4&scoped=true"
import script from "./ScansPage.vue?vue&type=script&lang=js"
export * from "./ScansPage.vue?vue&type=script&lang=js"
import style0 from "./ScansPage.vue?vue&type=style&index=0&id=6ed794d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed794d4",
  null
  
)

export default component.exports